import {
	CircleDollarSign,
	Infinity as InfinityIcon,
	type LucideIcon,
} from "lucide-react";
import type { ObjPathProxy } from "ts-object-path";
import {
	RENT_DRAWDOWN_MODES,
	type RentDrawdownMode,
} from "web_myplann/Goals/Forms/useGoalForm";
import type { MyPlannResourceDictionary } from "web_myplann/Infrastructure/Translations/ResourceDictionary";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

type RentDrawdownOption = {
	value: RentDrawdownMode;
	icon: LucideIcon;
	labelKey: ObjPathProxy<MyPlannResourceDictionary, string>;
};

const RENT_DRAWDOWN_OPTION_CONFIG = {
	"to-zero": {
		icon: CircleDollarSign,
		labelKey: Resources.Goals.Form.Pension.Drawdown.toZeroLabel,
	},
	perpetual: {
		icon: InfinityIcon,
		labelKey: Resources.Goals.Form.Pension.Drawdown.perpetualLabel,
	},
} satisfies Record<RentDrawdownMode, Omit<RentDrawdownOption, "value">>;

export const RENT_DRAWDOWN_OPTIONS: ReadonlyArray<RentDrawdownOption> =
	RENT_DRAWDOWN_MODES.map((value) => ({
		value,
		...RENT_DRAWDOWN_OPTION_CONFIG[value],
	}));
